export const config = {
  data() {
    return {
      columns: []
    };
  },
  methods: {
    getColumns() {
      let columns = [
        {
          title: '序号',
          type: 'index',
          align: 'center',
          width: 80
        },
        {
          title: '产品名称',
          key: 'productName',
          align: 'center',
          width: 170
        },
        {
          title: '产品编码',
          key: 'productCode',
          align: 'center',
          width: 140
        },
        {
          title: '产品分类',
          key: 'themeName',
          align: 'center',
          width: 120
        },
        {
          title: '图片',
          slot: 'img',
          align: 'center',
          minWidth: 352
        },
      ];
      if(this.curTab.name == '平台热卖') {
        columns.push({
          title: '图片类型',
          key: 'imgType',
          align: 'center',
          width: 100,
          render(h, params) {
            let text = '';
            const imgType = params.row.imgType;
            if (imgType == 1) {
              text = '首图';
            } else if (imgType == 2) {
              text = '常规图';
            }
            return <div>{text}</div>;
          }
        });
      }
      columns = columns.concat([
        {
          title: '上架状态',
          slot: 'publishStatus',
          align: 'center',
          width: 140
        },
        {
          title: '销售状态',
          slot: 'salesStatus',
          align: 'center',
          width: 140
        },
        {
          title: '排序',
          key: 'sort',
          align: 'center',
          width: 100
        },
        {
          title: '操作',
          slot: 'action',
          align: 'center',
          fixed: 'right',
          width: 140
        }
      ])
      this.columns = columns;
    }
  }
};
